
const ValuerAmendLinks = (props) => {
    const links = props.links ? props.links : [];
    const flex = props.flex ? props.flex : false;

    return (
        <div className={"valuer-amend-links-container" + (flex ? " flex" : "")}>
            {links && links.map((link, i) => {
                return (
                    <>
                        {link.text && link.url
                            ?
                            <div className="valuer-amend-form-link link">
                                <a href={link.url} target="_blank" rel="noopener noreferrer">{link.text}</a>
                            </div>
                            : null
                        }
                    </>
                )
            })}
        </div>
    )
}

export default ValuerAmendLinks